<template>
    <div :class="{ 'pb24': isMobile }">
        <div class="d-flex justify-content-between align-items-center mb16">
            <h4 class="text-black fsp20 neue mb-0 lh28">{{ $t('components.service.modal.Address.1') }}</h4>
            <Icon name="close" class="c24 pointer" @click="this.close"/>
        </div>
        <div class="bg-white rounded12" :class="{ 'p24': !isMobile }">
            <div class="d-flex flex-column gap16">
                <div>
                    <label class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.Address.6') }}</label>
                    <SelectSimple
                        :id="this.content.field.alias + '_' + 'country'"
                        :keywords.sync='this.copyContentAddr["address_" + this.content.field.alias +"_" + "country"]'
                        :hotUpdate='true'
                        :dataValue='this.copyContentAddr["address_" + this.content.field.alias + "_" + "country" + "_checked"]'
                        :isSearch="true"
                        searchType="address"
                        @updateParentState="(val) => {this.selectAddressField(val, 'country')}"
                    />
                </div>
                <div v-if="this.country != '643' && this.country != false">
                    <div class="d-flex flex-column gap16">
                        <div>
                            <label class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.Address.12') }}</label>
                            <InputSimple
                                :id="this.content.field.alias + '_' + 'locality'"
                                :dataValue='this.findAddressInArray(
                                    this.copyContentAddr["address_" + this.content.field.alias + "_" + "locality"],
                                    this.copyContentAddr["address_" + this.content.field.alias + "_" + "locality" + "_checked"])'
                                @updateParentState="(val) => {this.selectAddressField(val, 'locality')}"
                            />
                        </div>
                        <div>
                            <label class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.Address.18') }}</label>
                            <InputSimple
                                :id="this.content.field.alias + '_' + 'street'"
                                :dataValue='this.findAddressInArray(
                                    this.copyContentAddr["address_" + this.content.field.alias + "_" + "street"],
                                    this.copyContentAddr["address_" + this.content.field.alias + "_" + "street" + "_checked"])'
                                @updateParentState="(val) => {this.selectAddressField(val, 'street')}"
                            />
                        </div>
                        <div>
                            <label class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.Address.17') }}</label>
                            <InputSimple
                                :id="this.content.field.alias + '_' + 'postcode'"
                                :dataValue='this.findAddressInArray(
                                    this.copyContentAddr["address_" + this.content.field.alias + "_" + "postcode"],
                                    this.copyContentAddr["address_" + this.content.field.alias + "_" + "postcode" + "_checked"])'
                                @updateParentState="(val) => {this.selectAddressField(val, 'postcode')}"
                            />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="d-flex flex-column gap16">
                        <div v-for="(row, index) in this.control_13" :key="row.code">
                            <div v-if='this.copyContentAddr["address_" + this.content.field.alias +"_" + row.code]'>
                                <label class="fsp14 lh20 neue-roman mb8">{{row.name}}</label>
                                <div v-if="row.code=='housing' || row.code=='building'">
                                    <SelectSimple
                                        :id='this.content.field.alias + "_" + row.code'
                                        :keywords.sync='this.copyContentAddr["address_" + this.content.field.alias + "_" + row.code]'
                                        :hotUpdate='true'
                                        :dataValue='this.copyContentAddr["address_" + this.content.field.alias + "_" + row.code + "_checked"]'
                                        @updateParentState="(val) => {this.getAddress(val, row.code, index)}"
                                        :isSearch="true"
                                        searchType="address"
                                    />
                                </div>
                                <div v-else>
                                    <SelectSimple
                                        :id="this.content.field.alias + '_' + row.code"
                                        :keywords.sync='this.copyContentAddr["address_" + this.content.field.alias +"_" + row.code]'
                                        :hotUpdate='true'
                                        :disable='this.content.field.verification == 1
                                            || (row.code != "country" && this.copyContentAddr["address_" + this.content.field.alias + "_" + row.code] && this.copyContentAddr["address_" + this.content.field.alias + "_" + row.code].length == 0)
                                            || row.code == "postcode" ? true : false'
                                        :dataValue='this.copyContentAddr["address_" + this.content.field.alias + "_" + row.code + "_checked"]'
                                        @updateParentState="(val) => {this.getAddress(val, row.code, index)}"
                                        :isSearch="true"
                                        searchType="address"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if='this.invalidHint' class="error-notification mt16">
                <div class="error-notification__bar"></div>
                <span class="fsp16 lh24 neue">{{this.invalidHint}}</span>
            </div>
            <div class="d-flex gap16 mt24" :class="{ 'position-fixed bottom-0 start-0 end-0 bg-white border-t px24 py16': isMobile }">
                <Button :name="$t('components.service.modal.Address.5')" type="btn-warning" class="equal-width h48" :disabled="this.disable" :loader="this.loading" @click="this.save"/>
                <Button :name="$t('components.service.modal.Address.4')" type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.close"/>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import InputSimple from '@/components/service/InputSimple';
import SelectSimple from '@/components/service/SelectSimple';
import Icon from '@/components/icons/Icon';


export default {
    components: {
        Button,
        SelectSimple,
        InputSimple,
        Icon
    },
    props: {
        close: [Function],
    },
    data () {
        return {
            content: this.$store.state.modal.content,
            // mini-лоадер на кнопке "Сохранить", пока проверяется адрес
            loading: false,
            control_13: {
                // 0: {name: this.$t('components.service.modal.Address.6'), code: 'country'},//
	            1: {name: this.$t('components.service.modal.Address.7'), code: 'region'},//
	            2: {name: this.$t('components.service.modal.Address.8'), code: 'district'},//
	            3: {name: this.$t('components.service.modal.Address.9'), code: 'area'},//
	            4: {name: this.$t('components.service.modal.Address.10'), code: 'city'},//
	            5: {name: this.$t('components.service.modal.Address.11'), code: 'intercity'},//
	            6: {name: this.$t('components.service.modal.Address.12'), code: 'locality'},//
	            7: {name: this.$t('components.service.modal.Address.13'), code: 'street'},//
	            8: {name: this.$t('components.service.modal.Address.14'), code: 'additional'},//
	            9: {name: this.$t('components.service.modal.Address.15'), code: 'additional_slave'},//
	            10: {name: this.$t('components.service.modal.Address.16'), code: 'house'},
	            // 11: {name: 'Корпус', code: 'housing'},
	            // 12: {name: 'Строение', code: 'building'},
	            13: {name: this.$t('components.service.modal.Address.17'), code: 'postcode'},
            },
            data : {},
            country: false,
            countriesList: [],
            disable: true, 
            copyContentAddr: {},
            invalidHint: false
        }
    },
    created() {
        // console.log('created modal content', this.content);
        // console.log('created start old data', this.content.addr);
        // console.log('created start new data', this.copyContentAddr);
        this.copyContentAddr = JSON.parse(JSON.stringify(this.content.addr));
        // console.log('created after copy old data', this.content.addr);
        // console.log('created after copy new data', this.copyContentAddr);
        this.countriesList = this.getAllCountries();
        this.country = this.getCountryValue() ? this.getCountryValue() : false;
        // console.log('created country', this.country);
    },
    mounted() {
        
    },
    beforeUnmount() {

    },
    methods: {
        selectAddressField(val, name) {
            // console.log('this.content.field', this.content.field);
            if (val.repeat) {
                return;
            }

            if (name == 'country') {
                this.copyContentAddr["address_" + this.content.field.alias + "_" + 'locality' + "_checked"] = '';
                this.copyContentAddr["address_" + this.content.field.alias + "_" + 'street' + "_checked"] = '';
                this.copyContentAddr["address_" + this.content.field.alias + "_" + 'postcode' + "_checked"] = '';
            }

            // console.log('this.copyContentAddr', this.copyContentAddr);

            if (name == 'country' && val.value != '643' && val.value != false){
                // console.log('country en');
                this.copyContentAddr["address_" + this.content.field.alias + "_" + 'locality'] = [];
                this.copyContentAddr["address_" + this.content.field.alias + "_" + 'street'] = [];
                this.copyContentAddr["address_" + this.content.field.alias + "_" + 'postcode'] = [];
                this.country = val.value;
                this.copyContentAddr["address_" + this.content.field.alias + "_" + 'country' + "_checked"] = val.value; 
                return;
            }

            if (name == 'country' && val.value != false) {
                // console.log('country ru');
                delete this.copyContentAddr["address_" + this.content.field.alias + "_" + 'locality'];
                delete this.copyContentAddr["address_" + this.content.field.alias + "_" + 'street'];
                delete this.copyContentAddr["address_" + this.content.field.alias + "_" + 'postcode'];
                this.country = val.value;
                this.getAddress(val, 'country', 0);
                return;
            }
            
            this.copyContentAddr["address_" + this.content.field.alias + "_" + name + "_checked"] = val.value;
            // console.log('selectAddressField this.copyContentAddr', this.copyContentAddr);
            this.disable = false; 

        },
        getAllCountries() {
            return this.copyContentAddr["address_" + this.content.field.alias + "_country"];
        },
        addAddressPart(key) {
            return this.findAddressInArray(this.copyContentAddr["address_" + this.content.field.alias + key], this.copyContentAddr["address_" + this.content.field.alias + key + "_checked"], true)
            // return this.copyContentAddr["address_" + this.content.field.alias + key + "_checked"];
        },
        findAddressInArray(arr, key, inCopyContent = false) {
            let name = inCopyContent ? key : '';
            arr.forEach(e => {
                if (e.code == key) {
                    name = e.name;
                }
            })
            return name;
        },
        getAddressString() {
            // собираем текстовое значение адреса
            let textValue = '';

            // индекс
            textValue = this.addAddressPart('_postcode') ?
                textValue + this.addAddressPart('_postcode') :
                textValue;

            // страна в адресе
            const country = this.countriesList ? this.countriesList.find(item => item.code == this.country) : null;

            if (country) {
                textValue += ', ' + country.name;
            }

            // остальные части адреса
            textValue = this.addAddressPart('_locality') ?
                textValue + ', ' + this.addAddressPart('_locality') :
                textValue;

            textValue = this.addAddressPart('_street') ?
                textValue + ', ' + this.addAddressPart('_street') :
                textValue;

            // console.log('getAddressString textValue', textValue);
            return textValue;
        },
        getCountryValue() {
            const alias = this.content.field.alias;
            const countryKey = "address_" + alias + "_country" + "_checked";

            const countryVal = countryKey ? this.content.addr[countryKey] : '';
            return countryVal ? countryVal : '';
        },
        save() {
            const country = this.copyContentAddr["address_" + this.content.field.alias + "_" + "country_checked"];
            if (country != '643') {
                this.invalidHint = false;

                let preData = {
                    'country_type_info': '1',
                    'country': this.copyContentAddr["address_" + this.content.field.alias + "_" + "country_checked"],
                    'locality': this.findAddressInArray(this.copyContentAddr["address_" + this.content.field.alias + "_" + "locality"], this.copyContentAddr["address_" + this.content.field.alias + "_" + "locality_checked"], true),
                    'street':  this.findAddressInArray(this.copyContentAddr["address_" + this.content.field.alias + "_" + "street"], this.copyContentAddr["address_" + this.content.field.alias + "_" + "street_checked"], true),
                    'postcode':this.findAddressInArray(this.copyContentAddr["address_" + this.content.field.alias + "_" + "postcode"], this.copyContentAddr["address_" + this.content.field.alias + "_" + "postcode_checked"], true),
                    // 'region': this.copyContentAddr["address_" + this.content.field.alias + "_" + "region_checked"],
                    // 'region_type_info': '1',
                }

                this.loading = true;
                this.axios.post('checkAddress', {no_loader: true, data: preData}).then(res => {
                    if (res.data.body.result != '0') {
                        this.invalidHint = res.data.body.result_text;
                        return;
                    }
                    let keys = ['locality', 'street', 'postcode'];
                    keys.forEach(key => {
                        this.copyContentAddr["address_" + this.content.field.alias + "_" + key].push({
                            'name': preData[key],
                            'code': this.copyContentAddr["address_" + this.content.field.alias + "_" + key + "_checked"]
                        })
                    })
                    
                    this.copyContentAddr["address_" + this.content.field.alias + "_" + "house_checked"] = res.data.body.advanced.code;
                    this.returnValue();
                }).finally(() => {
                    this.loading = false;
                })

            } else {
                this.returnValue();
            }
            
        },
        returnValue() {
            this.content.addr = JSON.parse(JSON.stringify(this.copyContentAddr));
            this.content.updateState(
                {
                    id: this.content.field.alias,
                    value: this.content.addr["address_" + this.content.field.alias + "_" + "house_checked"],
                    new_addr: this.content.addr,
                }, 
                this.getCountryValue() == '643' ? 
                    this.content.addr["address_" + this.content.field.alias + "_" + "extra"][0]['value'] : 
                    this.getAddressString()
            );
            // console.log('after updateState', this.content.addr);
            this.close();
        },
        getAddress(val, key, index) {
            // console.log('getAddress arguments', val, key, index);
            // console.log('getAddress, copyContentAddr', this.copyContentAddr);
            if (val.repeat) {
                return;
            }
            let params = {};
            params[key] = val.value;
            // console.log(val);
            this.copyContentAddr["address_" + this.content.field.alias + "_" + key + "_checked"] = val.value; 
            if (key == 'housing' || key == 'building') {
                return;
            }
            this.axios.post('getlistAddress', {no_loader: true, data: params}).then(res => {
                let tables = res.data.body.tables;
                for (let i = 0; i < tables.length; i++) {
                    let name = tables[i].name;
                    if (tables[i].name == 'additionals') {
                        name = 'additional';
                    } else if (tables[i].name == 'additionals_slave') {
                        name = 'additional_slave';
                    } else if (tables[i].name == 'areas') {
                        name = 'area';
                    } else if (tables[i].name == 'cities') {
                        name = 'city';
                    } else if (tables[i].name == 'countries') {
                        name = 'country';
                    } else if (tables[i].name == 'districts') {
                        name = 'district';
                    } else if (tables[i].name == 'streets') {
                        name = 'street'
                    } else if (tables[i].name == 'regions') {
                        name = 'region';
                    } else if (tables[i].name == 'localities') {
                        name = 'locality';
                    } else if (tables[i].name == 'intercitys') {
                        name = 'intercity';
                    } 

                    if (i > index ) {
                        this.copyContentAddr["address_" + this.content.field.alias + "_" + name + "_checked"] = '';
                        this.copyContentAddr["address_" + this.content.field.alias + "_" + name] = '';
                        if (tables[i].colvalues.length > 0) {
                            this.copyContentAddr["address_" + this.content.field.alias +"_" + name] = tables[i].colvalues;
                        }
                    }

                }

                if (key == 'house') {
                    // console.log('house');
                        this.copyContentAddr["address_" + this.content.field.alias + "_" + "postcode"] = [];
                        this.copyContentAddr["address_" + this.content.field.alias + "_" + "postcode_checked"] = this.copyContentAddr["address_" + this.content.field.alias + "_" + "house_checked"];
                        this.copyContentAddr["address_" + this.content.field.alias + "_" + "house"].forEach(e => {
                            this.copyContentAddr["address_" + this.content.field.alias + "_" + "postcode"].push({code: e.code, name: e.postcode});
                        });
                        this.disable = false;
                }

                    
                // console.log('getAddress new object', this.copyContentAddr);
            })
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
}
</script>

<style lang="scss" scoped>
.error-notification {
    position: relative;
    overflow: hidden;
    background-color: rgba($color-invalid, 0.05);
    border: 1px solid $color-invalid;
    border-radius: 8px;
    padding: 16px 16px 16px 24px;
    color: $color-invalid;
}

.error-notification__bar {
    position: absolute;
    left: 0;
    top: 0;
    width: 8px;
    height: 100%;
    background-color: $color-invalid;
}
</style>